// The ONE global host of the canonical sale record drawer (see openSaleRecord.js): same RecordCardDrawerHost + OrderPreviewSections as Sales > Orders.
import React, { useEffect, useState } from 'react';
import RecordCardDrawerHost from '../pages/RecordCardDrawerHost';
import OrderPreviewSections from '../pages/Sales/invoicing/OrderPreviewSections';
import { OPEN_SALE_RECORD } from './openSaleRecord';

// mark the first cell whose text equals the highlight (a line id, an invoice / avoir / voucher number) and scroll to it
export function markHighlight(root, highlight) {
  if (!root || !highlight) return false;
  const hit = Array.from(root.querySelectorAll('td, dd, .val, .mono, span, b')).find(el => el.children.length === 0 && el.textContent.trim() === highlight);
  if (!hit) return false;
  hit.classList.add('rec-hl');
  if (hit.scrollIntoView) hit.scrollIntoView({ block: 'center' });
  return true;
}

export default function SaleRecordHost() {
  const [q, setQ] = useState(null);
  useEffect(() => {
    const on = (e) => setQ({ operation_id: e.detail.operation_id, highlight: e.detail.highlight, _ts: Date.now() });
    window.addEventListener(OPEN_SALE_RECORD, on);
    return () => window.removeEventListener(OPEN_SALE_RECORD, on);
  }, []);
  // the drawer loads asynchronously: retry the highlight a few times
  useEffect(() => {
    if (!q || !q.highlight) return undefined;
    let n = 0; const h = setInterval(() => { n += 1; if (markHighlight(document.querySelector('[data-testid="sale-record-drawer"]'), q.highlight) || n > 12) clearInterval(h); }, 400);
    return () => clearInterval(h);
  }, [q]);
  return <RecordCardDrawerHost query={q} testId="sale-record-drawer" onClose={() => setQ(null)} hideOrderLink onOpenRecord={x => setQ({ ...x, _ts: Date.now() })}
    extra={q && q.operation_id ? (c) => <OrderPreviewSections key={q.operation_id} op={q.operation_id} order={c.so} invoicing={c.invoicing} /> : null} />;
}
